import Masks from "../../../../shared/utils/mask.utils";

import { StandardGrpColumns } from "../../../../layout/grp-standard-screen";
import { IRessources } from "../../../../shared/interfaces/IFeatures";

const tableColumns: StandardGrpColumns<IRessources> = ({ columnClick }) => [
    {
        key: "res_nome",
        dataKey: "res_nome",
        name: "Nome da coluna",
        headerClick: columnClick,
    },
    {
        key: "res_proveniente",
        dataKey: "res_proveniente",
        name: "Tabela de origem",
        headerClick: columnClick,
    },
    {
        key: "created_at",
        dataKey: "created_at",
        name: "Criado em",
        render: (value) => Masks.date(value as string),
        headerClick: columnClick,
    },
    {
        key: "updated_at",
        dataKey: "updated_at",
        name: "Atualizado em",
        render: (value) => Masks.date(value as string),
        headerClick: columnClick,
    },
];

export default tableColumns;
